import React, { useRef, useEffect } from "react";
import { Typography, Box, Button, useTheme } from "@mui/material";
import Header from "../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { cobotColours } from "../../theme/theme"; // cobotColours is imported correctly
import api from "../../services/api";

const ClockOutPhoto = () => {
    const cobotTheme = useTheme(); // This will now correctly be the MUI theme hook
    const colors = cobotColours(cobotTheme.palette); // Pass MUI theme's palette
    const navigate = useNavigate();
    const { id } = useParams();

    const videoRef = useRef(null);
    // const canvasRef = useRef(null); // Canvas not strictly needed if not displaying/uploading photo

    useEffect(() => {
        const getCameraStream = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
            } catch (error) {
                console.error("Error accessing camera for clock-out:", error);
            }
        };

        getCameraStream();

        return () => {
            const video = videoRef.current;
            if (video && video.srcObject) {
                const stream = video.srcObject;
                const tracks = stream.getTracks();
                tracks.forEach(track => track.stop());
            }
        };
    }, []);

    const handleCaptureAndClockOut = async () => {
        // "Capture" photo (stop camera)
        if (videoRef.current && videoRef.current.srcObject) {
            // const context = canvasRef.current.getContext("2d"); // If drawing to canvas
            // context.drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
            const stream = videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null;
        }

        try {
            // Call the clock-out API
            const data = await api.employee.clockOut(id);

            if (data.success) {
                // console.log("Clocked out successfully");
                navigate("/"); // Navigate to the main dashboard (home page)
            } else {
                console.error("Clock-out failed:", data.message);
                // Optionally, display error to user and navigate somewhere appropriate
                // For now, navigate back to EmployeeClockedIn page on failure
                navigate(`/EmployeeClockedIn/${id}`); 
            }
        } catch (error) {
            console.error("Error during clock-out process:", error);
            // Navigate back to EmployeeClockedIn page on network error
            navigate(`/EmployeeClockedIn/${id}`);
        }
    };

    return (
        <Box
            height="100vh"
            display="flex"
            flexDirection="column"
            backgroundColor={colors.primary.special}
            padding={2}
        >
            <Header title="CLOCK OUT - TAKE PHOTO" />
            <Box flex={1} display="flex" flexDirection="column" justifyContent="center" alignItems="center" gap={2}>
                <Box justifyContent="center" display="flex" sx={{ width: "50%", borderRadius: "10px", overflow: "hidden" }}>
                    <video ref={videoRef} autoPlay playsInline style={{ width: "100%" }}></video>
                </Box>
                {/* <canvas ref={canvasRef} width="320" height="240" style={{ display: "none" }}></canvas> */}
                <Typography>Please align your face to the frame.</Typography>
                <Button variant="contained" color="primary" onClick={handleCaptureAndClockOut} sx={{padding: "10px 20px", fontSize: "16px"}}>
                    Confirm Clock Out & Capture
                </Button>
                 <Button 
                    variant="outlined"
                    color="secondary"
                    sx={{mt: 2}}
                    onClick={() => navigate(`/EmployeeClockedIn/${id}`)} // Go back if needed
                >
                    Cancel Clock Out
                </Button>
            </Box>
        </Box>
    );
};

export default ClockOutPhoto; 